import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';
import { TagOverrides } from 'baseui/tag';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '16px',
    },
  },
};

export const HEADER_TAGS: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginTop: '4px',
    },
  },
};

export const HEADER_TAG: TagOverrides = {
  Root: {
    style: {
      backgroundColor: THEME.colors.darkmuted500,
      height: '28px',
      paddingLeft: '32px',
      paddingRight: '32px',
      marginRight: '8px',
      marginLeft: 0,
    },
  },
  Text: {
    style: {
      fontSize: '10px',
      color: THEME.colors.primaryA,
      opacity: 0.8,
      maxWidth: 'inherit',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
};
